module.exports = __webpack_public_path__ + "img/2.73049895.png";